import * as yup from 'yup'

const regex = {
    email: /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i,
    //eslint-disable-next-line
    password: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/,
    upperCase: /[A-Z]/,
    lowerCase: /[a-z]/
}

export const validationSchema = yup.object().shape({
    email: yup
        .string()
        .email('The input is not valid E-mail!')
        .required('Email is required')
    ,
    password: yup
        .string()
        .required('Password is required')
        .min(8, 'Password must be minimum 8 characters')
        .matches(regex.password, 'Password must contain special character')
        .matches(regex.upperCase, 'Password must contain uppercase letter')
        .matches(regex.lowerCase, 'Password must contain lowercase letter')
        .when(['$firstName', '$lastName', '$email'], (firstName, lastName, email, schema, context) => {
            const { value } = context;
            const msg = 'Password cannot be the same as your'
            if (firstName === value) return schema.notOneOf([yup.ref('firstName')], `${msg} first name`)
            if (lastName === value) return schema.notOneOf([yup.ref('lastName')], `${msg} last name`)
            if (email === value) return schema.notOneOf([yup.ref('email')], `${msg} email`)
        })
})
